import moment                from "moment";
import Customer              from "../../../domain/customer/Customer";
import CustomerBirthDate     from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthday      from "../../../domain/customer/CustomerBirthday";
import CustomerBirthMonth    from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear     from "../../../domain/customer/CustomerBirthYear";
import CustomerContact       from "../../../domain/customer/CustomerContact";
import CustomerDetail        from "../../../domain/customer/CustomerDetail";
import CustomerId            from "../../../domain/customer/CustomerId";
import CustomerNumber        from "../../../domain/customer/CustomerNumber";
import CustomerRepository    from "../../../domain/customer/CustomerRepository";
import Address               from "../../../domain/fundamentals/address/Address";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Email                 from "../../../domain/fundamentals/email/Email";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import Phone                 from "../../../domain/fundamentals/phone/Phone";
import CreatedAt             from "../../../domain/fundamentals/trail/CreatedAt";
import Trail                 from "../../../domain/fundamentals/trail/Trail";
import UpdatedAt             from "../../../domain/fundamentals/trail/UpdatedAt";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CustomerDataSource    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class GetCustomer {
  constructor(
    private readonly dispatch,
    private readonly customerRepository: CustomerRepository = new CustomerDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute(customerId: CustomerId) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.customerRepository.findBy(customerId);
      const customer: Customer = new Customer(
        new CustomerId(response.data.id),
        new CustomerDetail(
          new CustomerNumber(response.data.detail.number),
          new Name(
            new LastName(response.data.detail.last_name),
            new FirstName(response.data.detail.first_name),
            new LastNameKana(response.data.detail.last_name_kana),
            new FirstNameKana(response.data.detail.first_name_kana),
          ),
          response.data.detail.gender_type,
        ),
        new CustomerBirthday(
          new CustomerBirthYear(response.data.birthday.year),
          new CustomerBirthMonth(response.data.birthday.month),
          new CustomerBirthDate(response.data.birthday.date),
        ),
        new CustomerContact(
          new Phone(response.data.contact.phone_number),
          new Email(response.data.contact.email),
        ),
        new Address(
          new PostalCode(response.data.address.postal_code),
          new Prefecture(response.data.address.prefecture),
          new City(response.data.address.city),
          new Street(response.data.address.street),
          new Building(response.data.address.building)
        ),
        new Trail(
          new CreatedAt(moment(response.data.trail.created_at)),
          new UpdatedAt(moment(response.data.trail.updated_at))
        )
      );

      this.customerRepository.setCustomer(customer);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCustomer;
